import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { trainingMonthlyPlanApi } from "../../../../../services/human-organization/training-course-monthly.service";

const selectHandler = (response: any) => {
  return trainingMonthlyPlanApi.toResponse(response);
};

export const useMTPRequest = () => {
  const { id } = useParams<{ id: string }>();
  return useQuery({
    queryKey: ["MTP-requests", id],
    queryFn: () => trainingMonthlyPlanApi.getRequest(id),
    select: selectHandler,
  });
};
